import { SimpleGrid, Stack } from "@chakra-ui/react";
import FinancialMetric from "../../../../components/FinancialMetric";
import { SectionWrapper } from "../SectionWrapper";
import type { HTMLAttributes } from "react";
import React from "react";

// Investment Data will use ticker in real implementation
interface InvestmentSummaryData {
  totalTransactions?: number;
  runningTotalRaised?: string;
  mostRecentValuation?: string;
  totalShares?: string;
  lastSharePrice?: string;
  totalInvestors?: number;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  investmentSummaryData: InvestmentSummaryData;
}

export default function SectionInvestmentSummary({ investmentSummaryData, ...props }: Props) {
  return (
    <SectionWrapper title="Investment Summary (CAD)" {...props}>
      <SimpleGrid columns={3} spacing="1.5rem" p="1rem">
        <Stack spacing="1rem">
          <FinancialMetric title="Total Transactions" value={investmentSummaryData.totalTransactions} />
          <FinancialMetric title="Total Shares" value={investmentSummaryData.totalShares} />
        </Stack>

        <Stack spacing="1rem">
          <FinancialMetric title="Running Total Raised" value={investmentSummaryData.runningTotalRaised} />
          <FinancialMetric title="Last Share Price" value={investmentSummaryData.lastSharePrice} />
        </Stack>

        <Stack spacing="1rem">
          <FinancialMetric title="Most Recent Valuation" value={investmentSummaryData.mostRecentValuation} />
          <FinancialMetric title="Total Investors" value={investmentSummaryData.totalInvestors} />
        </Stack>
      </SimpleGrid>
    </SectionWrapper>
  );
}
